import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { AllowedOrgUnit, AllowedOrgUnits, Combinator, CompositePredicate, OrgUnitsTypes, isCompositePredicate, isOrgUnitPredicate } from '../filter.type';
import { OrgUnitPredicateComponent } from './org-unit-predicate.component';

@Component({
    selector: 'composite-predicate',
    templateUrl: './composite-predicate.component.html',
    styleUrls: ['./composite-predicate.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatMenuModule,
        OrgUnitPredicateComponent
    ]
})
export class CompositePredicateComponent implements OnChanges {
    @Input()
    topLevel = false;

    @Input()
    predicate: CompositePredicate;

    @Input()
    orgUnits: AllowedOrgUnits[];

    @Output()
    orgUnitValueChange = new EventEmitter<{ value: AllowedOrgUnit, id: string }>();

    @Output()
    combinatorChange = new EventEmitter<{ combinator: Combinator, id: string }>();

    @Output()
    removePredicate = new EventEmitter<string>();
    
    @Output()
    orgUnitValueAdd = new EventEmitter<{ orgUnitType: OrgUnitsTypes | 'tag', id: string }>();

    combinators: Combinator[] = ['OR', 'AND'];
    orgUnitTypes: (OrgUnitsTypes | 'tag')[];

    ngOnChanges() {
        if (this.orgUnits) {
            this.orgUnitTypes = this.orgUnits.map(orgUnit => {
                return orgUnit.type;
            });
        }
    }

    isOrgUnitPredicate = isOrgUnitPredicate;
    isCompositePredicate = isCompositePredicate;

    doUpdateOrgUnitValue(valueChange: { value: AllowedOrgUnit, id: string }) {
        this.orgUnitValueChange.emit(valueChange);
    }

    doUpdateCombinator(combinatorChange: { combinator: Combinator, id: string }) {
        this.combinatorChange.emit(combinatorChange);
    }

    doRemovePredicate(id: string) {
        this.removePredicate.emit(id);
    }

    doAddFilterInGroup(valueAdd: { orgUnitType: OrgUnitsTypes | 'tag', id: string }) {
        this.orgUnitValueAdd.emit(valueAdd);
    }

}